// extracted by mini-css-extract-plugin
module.exports = {"heading":"Page_heading__2xENi","textContainer":"Page_textContainer__3zNGK"};